<template>
    <div>
        <inspeccionTabs 
        isFront
        />
    </div>
</template>

<script>
    import inspeccionTabs from "components/inspeccionTabs/inspeccionTabs";
    export default {
        components: {
            inspeccionTabs,
        },
    }
</script>

<style lang="scss" scoped>

</style>